const diferenciais = [
  { icon: 'ri-eye-2-line', title: 'Visão de Auditoria Aplicada', desc: 'Cada processo contábil é revisado com o rigor de quem audita — identificando o que outros escritórios deixam passar.' },
  { icon: 'ri-compass-3-line', title: 'Atuação Estratégica', desc: 'Não atuamos apenas operacionalmente. Somos parceiros estratégicos focados em resultado financeiro real para o negócio.' },
  { icon: 'ri-coins-line', title: 'Foco em Resultado Financeiro', desc: 'Tudo que fazemos tem um objetivo claro: reduzir custos, aumentar margens e melhorar a saúde financeira da empresa.' },
  { icon: 'ri-user-heart-line', title: 'Atendimento Próximo e Consultivo', desc: 'Você não é mais um cliente. Você tem um parceiro dedicado que conhece seu negócio e antecipa necessidades.' },
  { icon: 'ri-money-dollar-circle-line', title: 'Identificação de Economias', desc: 'Mapeamos oportunidades de economia tributária que passam despercebidas, gerando retorno concreto para a empresa.' },
  { icon: 'ri-shield-star-line', title: 'Conformidade Total', desc: 'Garantimos conformidade fiscal e contábil completa, eliminando riscos e possíveis autuações da Receita Federal.' },
];

const steps = [
  { num: '01', label: 'Diagnóstico inicial da empresa' },
  { num: '02', label: 'Identificação de riscos e oportunidades' },
  { num: '03', label: 'Estruturação contábil e fiscal' },
  { num: '04', label: 'Acompanhamento contínuo com foco em resultado' },
];

export default function DiferenciaisSection() {
  return (
    <section id="diferenciais" className="py-24 bg-[#0f2651]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-[#c9a84c] text-sm font-bold tracking-widest uppercase">Nossos Diferenciais</span>
          <h2 className="font-serif text-5xl md:text-6xl font-bold text-white mt-3 mb-5">
            Por que escolher<span className="text-[#c9a84c]"> a RCP?</span>
          </h2>
          <p className="text-white/50 text-lg max-w-xl mx-auto">
            Somos diferentes porque pensamos diferente. Veja o que nos distingue de um escritório contábil comum.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mb-20">
          {diferenciais.map((d) => (
            <div key={d.title} className="bg-white/5 border border-[#c9a84c]/25 rounded-lg p-7 hover:bg-[#c9a84c]/10 hover:border-[#c9a84c]/50 transition-all duration-300">
              <div className="w-12 h-12 flex items-center justify-center bg-[#c9a84c]/15 rounded-lg text-[#c9a84c] mb-5">
                <i className={`${d.icon} text-2xl`} />
              </div>
              <h3 className="text-lg font-bold text-white mb-2">{d.title}</h3>
              <p className="text-white/50 text-base leading-relaxed">{d.desc}</p>
            </div>
          ))}
        </div>

        <div className="border-t border-white/10 pt-16">
          <div className="text-center mb-10">
            <span className="text-[#c9a84c] text-sm font-bold tracking-widest uppercase">Como Trabalhamos</span>
            <h3 className="font-serif text-4xl font-bold text-white mt-3">Nossa metodologia em 4 etapas</h3>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {steps.map((step, idx) => (
              <div key={step.num} className="relative">
                <div className="bg-[#c9a84c]/15 border border-[#c9a84c]/30 rounded-lg p-6 hover:bg-[#c9a84c]/25 hover:border-[#c9a84c]/50 transition-all duration-300">
                  <div className="text-4xl font-bold text-[#c9a84c]/40 mb-3">{step.num}</div>
                  <p className="text-white text-base font-semibold leading-snug">{step.label}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
